<app-header />

<main class="flex-shrink-0 content-space-t-1 mt-4 content-space-b-1">
  <router-outlet />
</main>

<app-footer [bgClass]="'bg-white'" [isComing]="true" [textClass]="'text-dark'" />
<app-support-buttons />
